var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (JSON, fieldsetCounter, globals, id, sliderOptions) {
      pug_mixins["intro"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;intro&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;intro&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;intro&quot;)\"\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;intro&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cp class=\"error\" ng-show=\"component.is_already_used\"\u003ESie nutzen bereits diesen Baustein!\u003C\u002Fp\u003E\u003Ca class=\"button button-primary float-right\" ng-click=\"component.toggleStep(&quot;values&quot;)\" ng-if=\"!component.is_pc\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003Ca class=\"button button-primary right\" ng-click=\"component.goToMPP()\" ng-if=\"component.is_pc\" data-cy=\"neo.preCheckout.pcLeasing.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"component.isBonusCancelled() || !component.isProjectApproved()\"\u003E\u003Cp class=\"red\"\u003EDer Checkout ist leider nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!component.hasSachbezugCheckouts &amp;&amp; component.all_active_checkouts.length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.all_active_checkouts\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan class=\"red\" ng-if=\"component.hasSachbezugCheckouts\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug'] &amp;&amp; component.allSachbezugCheckouts['sachbezug'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | VORTEILSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_pluxee'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_pluxee'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | BENEFITS CARD\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_pluxee']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_profit'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_profit'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | FITNESSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_profit']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"!component.isBonusDefaultStartDateCheckoutAvailable &amp;&amp; !component.is_component_cashback\"\u003E\u003Cp class=\"red\"\u003EDiese Wahlleistung steht in diesem Projekt aktuell nicht zur Verfügung.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"(component.is_component_cashback &amp;&amp; !component.is_cashback_request_available) || !component.isDecisionDateValid()\"\u003E\u003Cp class=\"red\"\u003EDer Zeitraum zur Beantragung dieser Wahlleistung ist abgelaufen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.isPcBlocked\"\u003E\u003Cp class=\"red\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.disableCheckoutIfMultipleSachbezugCheckouts\"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003ESie beantragen bereits die Wahlleistung - {{ component.sachbezugCheckedoutComponent }}. Bitte schließen Sie zuerst diese Beantragung ab.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"component.navigateBackToDashboard()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.addComponentToEmployeeBonusComponents()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; !component.is_component_cashback &amp;&amp; component.canContinue()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.continueToCashbackRequestStep()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; component.is_component_cashback &amp;&amp; component.is_cashback_request_available\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" overlay=\"!$ctrl.isLoaded\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s {{ $ctrl.neo_component.title }}') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cp class=\"red\" ng-if=\"$ctrl.isBlockedForPcLeasing\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"$ctrl.navigateBackToDashboard()\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"$ctrl.isLoaded\"\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"$ctrl.enterStepTwo()\" ng-if=\"$ctrl.canEnterStepTwo() &amp;&amp; $ctrl.doesUserHasSalary\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.canEnterStepTwo()\"\u003E\u003Cp class=\"error\"\u003EDer Abruf von PC-Leasing ist akuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.doesUserHasSalary\"\u003E\u003Cp class=\"error\"\u003EEine Beantragung ist aufgrund fehlender Einstellungen aktuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["values"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;values&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;values&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;values&quot;)\"\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;values&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Ca class=\"button button-primary right\" ng-disabled=\"!component.canExitValuesScreen()\" ng-click=\"component.toggleStep(&quot;checkout&quot;)\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonCancel\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!component.toAllowComponentAddition()\" ng-if=\"component.step2SelectionPossible()\" ng-click=\"component.stepValuesHandler &amp;&amp; component.stepValuesHandler()\" data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonConfirm\"\u003E" + (pug.escape(null == (pug_interp = data.step2ButtonTitle || 'Auswahl übernehmen') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!$ctrl.toAllowComponentAddition()\" ng-if=\"$ctrl.step2SelectionPossible()\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EAuswahl übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["slider"] = pug_interp = function(data, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={}; }
if (undefined === data.htmlClass) { data.htmlClass = 'currency'; }
if (undefined === data.value) { data.value = '0'; }
if (false === data.value) { delete data.value; }
if (!data.from ) { data.from = 0; }
if (undefined === data.if) { data.if = 'false'; }

// sliderOptions.steps? to define where the steps are ended?
// Formula to calculate split?

sliderOptions = '';

if (undefined !== data.from) { sliderOptions += 'component.sliderOptions.from = ' + JSON.stringify(data.from) +';'; }
if (undefined !== data.to) { sliderOptions += 'component.sliderOptions.to = component.sliderOptions.to || ' + JSON.stringify(data.to) +';'; }
if (undefined !== data.value) { sliderOptions += 'component.sliderOptions.value = ' + JSON.stringify(data.value) +';'; }

pug_html = pug_html + "\u003Cspan" + (" style=\"display:none\""+pug.attr("ng-init", sliderOptions, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([data.htmlClass], [true]),"id": "mySlider1","ng-if": "component.model","ng-model": pug.escape(data.model || 'component.model.value'),"type": "number","slider": pug.escape(true),"options": pug.escape(data.sliderOptions || data.options || 'component.sliderOptions'),"data-cy": pug.escape(cyData)},attributes]), true)) + "\u003E";
};


























































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv ng-if=\"(component.loading.parent || component.loading.child)\"\u003ELoading\u003C\u002Fdiv\u003E\u003Cwizard hide-indicators=\"true\" ng-if=\"!(component.loading.parent || component.loading.child)\" on-finish=\"component.wizardFinished()\" on-cancel=\"component.wizardCanceled()\"\u003E\u003Cwz-step wz-title=\"Intro\" edit-mode=\"true\"\u003E";
pug_mixins["intro"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cp\u003ESie erhalten von Ihrem Arbeitgeber ein monatliches Guthaben, das Sie zusätzlich zu Ihrem regulären Gehalt verwenden können. Die Höhe Ihres monatlichen Zuschusses sehen Sie auf der rechten Seite. Bitte beachten Sie, dass Sie nur einen Sachbezug zur gleichen Zeit nutzen können, sofern Ihr Unternehmen mehrere Möglichkeiten anbietet.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cp class=\"strong\"\u003EEinkaufen, Essen, Tanken - alles mit einer Karte!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cp style=\"margin: 0px\"\u003EMit der Benefits Card von Pluxee können Sie bei unzähligen Akzeptanzstellen in Ihrer\u003C\u002Fp\u003E\u003Cp\u003ERegion ganz bequem shoppen, ohne dafür das eigene Geld verwenden zu müssen.\u003C\u002Fp\u003E\u003Cp style=\"margin: 0px\"\u003EDenn das Guthaben hierfür wird Ihnen von Ihrem Arbeitgeber zusätzlich zum regulären\u003C\u002Fp\u003E\u003Cp\u003EGehalt zur Verfügung gestellt und auf eine Gutscheinkarte, die Benefits Card, geladen.\u003C\u002Fp\u003E\u003Cp class=\"strong\"\u003EDas Beste daran: Auf das Guthaben fallen keine Steuer- oder Sozialabgaben an.\u003C\u002Fp\u003E\u003Cp\u003EEgal ob Tankstellen, klassische Supermärkte, Restaurants oder weitere Einzelhändler: Nutzen Sie die Benefits Card einfach als kontaktloses Zahlungsmittel bei regionalen Einlöse-Stellen in Ihrer Nähe.\u003C\u002Fp\u003E\u003Cp style=\"margin: 0px\"\u003E\u003Ca href=\"https:\u002F\u002Fapp.sodexo.de\u002Fmysodexo\" target=\"_blank\"\u003EHier\u003C\u002Fa\u003E können Sie ganz bequem die Einlöse-Stellen in Ihrer Region ausfindig machen.\u003C\u002Fp\u003E\u003Cp\u003EEinfach die Postleitzahl eingeben und durch das Angebot stöbern.\u003C\u002Fp\u003E\u003Cp style=\"margin: 0px\"\u003EIn der praktischen Pluxee-App finden Sie ebenfalls eine Übersicht der Akzeptanzstellen\u003C\u002Fp\u003E\u003Cp style=\"margin: 0px\"\u003Eund des zur Verfügung stehenden Guthabens. Suchen Sie im App Store oder Google\u003C\u002Fp\u003E\u003Cp\u003EPlay Store nach „Pluxee“ und laden sich die App herunter.\u003C\u002Fp\u003E\u003Cp\u003EWir wünschen viel Freude beim „kostenlosen\" Shoppen!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
}, {
      process: 'BONUS',
      title: 'So funktioniert´s',
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Values\" edit-mode=\"true\" wz-data=\"{calculation_promise : component.calculation_promise}\" canenter=\"component.waitForCalculation\"\u003E";
pug_mixins["values"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv ng-if=\"component.model.sliders\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"cent_slider\"\u003E";
pug_mixins["slider"](
              {
                model: 'component.model.advantage',
                options: 'component.model.sliders.advantage'
              },
              'bonus.preCheckout.employeeBenefit.wizardConfig.slider'
            );
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003EBitte geben Sie die gewünschte monatliche Höhe des Sachbezug an.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E";
pug_mixins["slider"](
            {
              model: 'component.model.months',
              options: 'component.model.sliders.months',
              htmlClass: false
            },
            'bonus.preCheckout.employeeBenefit.wizardConfig.slider'
          );
pug_html = pug_html + "\u003Cp\u003EBitte geben Sie die Anzahl der Monate an, in denen Sie die Leistung beanspruchen möchten.\u003C\u002Fp\u003E";
},
attributes: {"name": "component.forms.value_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cp ng-if=\"component.model.months &gt; 1\"\u003ESie erhalten von {{component.bonus_start_month_year | date : component.dateFormat }} bis {{ component.bonus_end_month_year | date : component.dateFormat }} einen Betrag von {{component.model.per_month_value | currency:'EUR' }} monatlich.\u003C\u002Fp\u003E\u003Cp ng-if=\"component.model.months === 1\"\u003ESie erhalten im {{component.bonus_start_month_year | date : component.dateFormat }} einen Betrag von {{component.model.per_month_value | currency:'EUR' }} monatlich.\u003C\u002Fp\u003E";
}
}, {
      process: 'BONUS',
      title: 'Bitte geben Sie den monatlichen Betrag für Ihr Konto ein.',
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003C\u002Fwizard\u003E";
    }.call(this, "JSON" in locals_for_with ?
        locals_for_with.JSON :
        typeof JSON !== 'undefined' ? JSON : undefined, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "sliderOptions" in locals_for_with ?
        locals_for_with.sliderOptions :
        typeof sliderOptions !== 'undefined' ? sliderOptions : undefined));
    ;;return pug_html;};
module.exports = template;